import { Audio, Images } from "@abcya/abcya_phaser";
import { enableUserClick } from "../phaserHelpers";
import TitleScene from "../scenes/TitleScene";
import SoundAssetKeys from "../SoundAssetKeys";
import UIAssetKeys from "../UIAssetKeys";
import PauseDialog from "./PauseDialog";

export default class Hud extends Phaser.GameObjects.Container
{
	constructor(scene, atlasId)
	{
		super(scene);

        this.atlasId = atlasId;

        this.isPaused = false;
        this.muteState = this.scene.sound.mute;

        this.bg = Images.addImage(0, 0, UIAssetKeys._HUD_Bg, this).setOrigin(0);
        this.ice = Images.addImage(0, 0, UIAssetKeys._HUD_Snow, this).setOrigin(0);
        this.bg.x = ~~((this.ice.width-this.bg.width)/2);

       // this.lblLevel = Images.addImage(152,  8, UIAssetKeys._LABEL_Level_1, this).setOrigin(0);
        this.lblLevel = this.scene.add.bitmapText(144, 4, 'darkblueFont', 'Level 1', 24);
        //this.scene.add.bitmapText()
        this.iconCount = Images.addImage(240,  7, UIAssetKeys._ICON_Ornament, this).setOrigin(0);
        this.txtCount = this.scene.add.bitmapText(this.iconCount.x+this.iconCount.width+10, 6, 'blueFont', '0', 18, this);
        this.lblScore = Images.addImage(369,  7, UIAssetKeys._LABEL_Score, this).setOrigin(0);
        this.txtScore = this.scene.add.bitmapText(this.lblScore.x+this.lblScore.width+18, 3, 'blueFont', '0', 24, this);
        this.add([this.lblLevel, this.txtCount, this.txtScore]);

        let fn = "BUTTON_Audio_ON";
        if (this.muteState) {
            fn = "BUTTON_Audio_OFF";
        }
        this.btnAudioToggle = Images.addImage(45, 17, fn, this).setOrigin(0);
        enableUserClick(this.btnAudioToggle, this.onClickAudio, this);
        this.btnMenu = Images.addImage(586, 17, UIAssetKeys._BUTTON_Menu, this).setOrigin(0);
        enableUserClick(this.btnMenu, this.onClickMenu, this);
        this.barMainTimerBg = Images.addImage(139, 48, UIAssetKeys._TimerBar_Bg, this).setOrigin(0);
        this.barMainTimer = Images.addImage(139, 48, UIAssetKeys._TimerBar_RedStripe, this).setOrigin(0);
        this.barFullWidth = this.barMainTimer.width;
        this.timerRect = new Phaser.GameObjects.Rectangle(this.scene, 0, 0, this.barFullWidth, this.barMainTimer.height);

        this.barMainTimer.setCrop(this.timerRect);

        this.pauseDialog = null;
    }

    onClickAudio(sprite, pointer) {   
        this.muteState = !this.muteState;     
        this.scene.sound.mute = this.muteState;

        Audio.playOneShot(SoundAssetKeys._click_Copy, this.scene);

        let fn = "BUTTON_Audio_ON";
        if (this.muteState) {
            fn = "BUTTON_Audio_OFF";
        }
        this.btnAudioToggle.setFrame(fn);
    };

    onClickMenu(sprite, pointer) {
        Audio.playOneShot(SoundAssetKeys._click_Copy, this.scene);
        if (!this.pauseDialog) {
            this.pauseDialog = new PauseDialog(this.scene, this.scene.game, Images.DEFAULT_ATLAS, this.pausedCallback.bind(this));
            this.scene.add.existing(this.pauseDialog);
        }
        this.isPaused = true;
    };

    pausedCallback(value) {
        if (value === "menu") {
            this.scene.scene.start(TitleScene.KEY);
            this.pauseDialog.pendingDestroy = true;
            this.pauseDialog = null;
        }else{
            this.pauseDialog.destroy();
            // this.pauseDialog.pendingDestroy = true;
            this.isPaused = false;
            this.pauseDialog = null;

        }
    };

    updateCount(count, total) {
        this.txtCount.alpha = 1;
        this.txtCount.text = count + "/" + total;
    };

    updateTimer(totalTime, timeRemaining) {
        const percent = timeRemaining / totalTime;
        this.timerRect.width = this.barFullWidth * percent;
        this.barMainTimer.setCrop(this.timerRect);
    };

    updateLevel(value) {
        this.lblLevel.text = "Level " + value;
        this.txtCount.alpha = 0;
    };

    updateScore(value) {
        this.txtScore.text = value.toString();
    };
}

/*(function () {

    window.BOP.Hud = function(game, atlasId) {
        Phaser.Group.call(this, game);
        
        this.setup();
    };

    var me = BOP.Hud.prototype = Object.create(Phaser.Group.prototype);
    BOP.Hud.prototype.constructor = BOP.Hud;


    me.setup = function() {

        
    };

    /* INPUT *//*
    me.onClickMenu = function(sprite, pointer) {
        BOP.audio.playClick();
        if (!this.pauseDialog) {
            this.pauseDialog = new BOP.PauseDialog(this.game, this.atlasId, this.pausedCallback.bind(this));
        }
        this.isPaused = true;
    };

    me.

    me.

    me.

    me.

    me.

    me.


    me.gameOver = function() {
        removeUserClick(this.btnMenu);
    };

    me.hideUI = function() {
        this.lblLevel.destroy();
        this.iconCount.destroy();
        this.txtCount.destroy();
        this.lblScore.destroy();
        this.txtScore.destroy();
        this.ice.destroy();
        this.bg.destroy();
        this.btnAudioToggle.destroy();
        this.btnMenu.destroy();
        this.barMainTimerBg.destroy();
        this.barMainTimer.destroy();
    };



    me.housekeeping = function() {

    };


})();*/